import React,{useState,useEffect} from 'react'
import { Checkbox, Col, Row } from 'antd';
import BtnRightArrow from '../../Assets/images/btn-right-arrow.svg'
import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
import {fetchLandDescriptions} from '../../Utils/landgetapi'
import { get } from '../../Services/Api';
import Loading from '../../Components/Loading';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedValues } from '../../Redux/SelectedSpace';

const PlanningBuild = () => {
    const dispatch = useDispatch();

    // const [selectedValues, setSelectedValues] = useState([]);
    const [landUses, setLandUses] = useState([]);
    const [loading,setLoading] = useState(false);

    const navigate = useNavigate();

    const admin_firstname = localStorage.getItem('firstName')

    const {selectedValues} = useSelector((state)=> state.selectedSpace);

    const handleSpaceSelction = (e) =>{
        // navigate('planning-to-theater',{state:{selectedValues}})
         navigate('planning-to-theater')
    }

    const handleSelectionSpace = (checkedValues)=>{
        // setSelectedValues(checkedValues)
        dispatch(setSelectedValues(checkedValues))
    }

    useEffect(() => {
        setLoading(true)
        const loadLandDescriptions = async () => {
          try {
            const response = await get('landdescription')
            const data = response.data;
            
            // Extract unique Land Use values
            const uniqueLandUses = Array.from(new Set(data.map(item => item['Land Use'])));
            console.log("uniqueLandUses:", uniqueLandUses);
            setLoading(false);
    
            setLandUses(uniqueLandUses);
          } catch (error) {
            console.error("Error fetching land description data:", error);
          }
        };
    
        loadLandDescriptions();
      }, []);
    return (
        <>
        {loading ?(
            <div>
                <Loading/>
            </div>
        ):( <>
            <div className="d-flex align-items-center justify-content-center">
                <div>
                    <a href="" className="number-active" >1 </a>
                </div>
                <div className="line"></div>
                <div>
                    <a href="" className="defualt-active" >2 </a>
                </div>
            </div>
            <div className="w-100 text-center my-5 heading-label">
                <h1 className="mb-0">
                <span className="typing line1">Hi {admin_firstname},</span>
                </h1>
                <h1>
                <span className="typing line2">Planning to build a Space?</span>
                </h1>
            </div>
            <div className="select-form-section my-5">
                <div className="d-flex mb-4 position-relative">
                    <input 
                    type="text"
                    value={selectedValues}
                    placeholder="select the space"
                    className="w-100 buid-input form-control" 
                    style={{padding: '.375rem 3.95rem .375rem .75rem'}}
                    />
                    <button 
                    className="btn-rounded"
                    onClick={handleSpaceSelction}
                    >
                        <img src={BtnRightArrow} style={{ width: '10px' }} />
                    </button>
                </div>
                <div className="d-flex align-items-center mt-4">
                    {/* <div> */}
                    <Checkbox.Group
                        style={{
                            width: '100%',
                        }}
                        onChange={handleSelectionSpace}
                    >
                        {/* <Row>
                            <Col className="checkbox-rounded">
                                <Checkbox value="Office">Office</Checkbox>
                            </Col>
                            <Col className="checkbox-rounded">
                                <Checkbox value="Gym">Gym</Checkbox>
                            </Col>
                            <Col className="checkbox-rounded">
                                <Checkbox value="Coffee Shop">Coffee Shop</Checkbox>
                            </Col>
                            <Col className="checkbox-rounded">
                                <Checkbox value="Retail Shop">Retail Shop</Checkbox>
                            </Col>
                            <Col className="checkbox-rounded">
                                <Checkbox value="Film Theater">Film Theater</Checkbox>
                            </Col>
                            <Col className="checkbox-rounded">
                                <Checkbox value="Salon">Salon</Checkbox>
                            </Col>
                        </Row> */}
                        <Row>
                            {landUses.map((landUsed,index)=>(
                            <Col key={index} className="checkbox-rounded">
                                <Checkbox value={landUsed}>{landUsed}</Checkbox>
                            </Col>
                            ))}
                        </Row>
                    </Checkbox.Group>
                    {/* </div> */}
                </div>
            </div>
            </>
            )}
        </>
    )
}

export default PlanningBuild